import { useEffect, useState } from "react";
import { StoryScreen } from "../../../components/stories/StoryScreen";
import { getTicketsStoryImage } from "../../../api/transport/configurationTransport";
import { saveTicketState, shouldShowTicket } from "./helpers";

export const TicketsStoryWidget = () => {
    const [image, setImage] = useState<string | null>(null);
    useEffect(() => {
        if (!shouldShowTicket()) {
            return;
        }

        console.log('shouldShowTicket(): ', shouldShowTicket());

        saveTicketState();

        getTicketsStoryImage().then((data) => {
            setImage(data);
        });
    }, []);

    if (!image) {
        return null;
    }

    return (
        <StoryScreen
            action={() => window.open("https://fcrodina.com/ticket-id4/")}
            image={image}
        />
    );
}
